// FAQ content: stable IDs and internal aliases are shared across languages.
// sourceQuestions map to the original 41-question inventory for editorial review.
export const participationFaq = {
  "it": [
    {
      "id": "faq-start",
      "title": "Iniziare e partecipare",
      "symbol": "handshake",
      "legacyIds": [
        "faq-section-1"
      ],
      "items": [
        {
          "id": "faq-why-join",
          "question": "Perché partecipare se ho già un sito o i social?",
          "paragraphs": [
            "PlantAdopting affianca il tuo sito e i social con una scheda collegata al territorio, alle attività e al patrimonio vivente. Aiuta chi esplora a capire cosa fai e come contattarti; non garantisce clienti, contributi o collaborazioni."
          ],
          "keywords": [
            "vivaio nursery cittadini adottanti citizens adopters vantaggi benefits",
            "Perché partecipare se ho già un sito o i social?",
            "Perché dovrei iscrivermi a PlantAdopting?",
            "Why join if I already have a website or social media?",
            "Why should I join PlantAdopting?"
          ],
          "sourceQuestions": [
            1,
            4
          ],
          "links": [
            {
              "to": "/for-farmers",
              "label": "Percorso agricolo"
            },
            {
              "to": "/for-entities",
              "label": "Organizzazioni, professionisti e luoghi"
            }
          ]
        },
        {
          "id": "faq-explore-account",
          "question": "Serve un account per esplorare?",
          "paragraphs": [
            "No. Mappa, Atlante, cataloghi e schede pubbliche sono consultabili senza account. Per pagare tramite PlantAdopting e gestire le tue schede serve un account gratuito; contatti e attività su siti esterni seguono il canale indicato."
          ],
          "keywords": [
            "Devo iscrivermi anche solo per curiosare?",
            "Devo registrarmi per esplorare?",
            "Do I need to register just to look around?",
            "Do I need an account to explore?"
          ],
          "sourceQuestions": [
            5,
            11
          ],
          "links": [
            {
              "to": "/how-it-works#account-payments",
              "label": "Account e partecipazione"
            }
          ]
        },
        {
          "id": "faq-activities",
          "question": "Quali attività posso proporre?",
          "paragraphs": [
            "Le tipologie disponibili sono acquisto, adozione, visita, formazione, volontariato, sostegno e progetto. La scelta dipende dall’attività concreta e dai requisiti applicabili, non soltanto dalla categoria del promotore.",
            "Puoi descrivere, per esempio, una produzione agricola, una visita aziendale, un laboratorio o il recupero di un giardino. Per creare opportunità occorre Pro, salvo un progetto Free per Comuni ed enti pubblici. Pubblicazione, prenotazione e incasso sono distinti; gli eventuali shop o contatti esterni seguono il canale indicato."
          ],
          "keywords": [
            "acquisti prodotti allevamento siepi impollinatori orto scolastico acqua purchase livestock hedgerow pollinator school garden water",
            "Quali opportunità possono proporre i diversi soggetti?",
            "Quali esempi di progetti possono proporre Comuni ed enti?",
            "Cosa può proporre un’azienda agricola o un allevamento?",
            "Which opportunities can different subjects offer?",
            "What projects can municipalities and public bodies propose?",
            "What can a farm or livestock farm offer?"
          ],
          "sourceQuestions": [
            30,
            32,
            34
          ],
          "links": [
            {
              "to": "/for-farmers",
              "label": "Attività agricole e vivaistiche"
            },
            {
              "to": "/for-entities",
              "label": "Enti, professionisti e luoghi"
            },
            {
              "to": "/how-it-works",
              "label": "Formule di partecipazione"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-accounts",
      "title": "Account e profili",
      "symbol": "citizen",
      "legacyIds": [
        "faq-section-2"
      ],
      "items": [
        {
          "id": "faq-profile-visible",
          "question": "Come rendo visibile la mia scheda?",
          "paragraphs": [
            "Crea il tuo account personale, aggiungi la realtà che sei autorizzato a rappresentare o gestire, poi completa e salva la scheda: sarà consultabile nell’Atlante. Account e scheda sono distinti; non occorre un ulteriore passaggio di pubblicazione."
          ],
          "keywords": [
            "Come rendo visibile la mia scheda?",
            "How do I make my profile visible?"
          ],
          "sourceQuestions": [
            3
          ],
          "links": [
            {
              "to": "/terms#terms-content",
              "label": "Contenuti e autorizzazioni"
            }
          ]
        },
        {
          "id": "faq-adopter-and-manager",
          "question": "Posso essere adottante e gestire un’attività?",
          "paragraphs": [
            "Sì. Lo stesso account può partecipare e gestire più soggetti propri. Se non hai un’attività da registrare, puoi usare la piattaforma come adottante senza creare una scheda aziendale."
          ],
          "keywords": [
            "Posso essere adottante e gestire un’attività?",
            "Can I be an adopter and manage an activity?"
          ],
          "sourceQuestions": [
            12
          ],
          "links": []
        },
        {
          "id": "faq-existing-profile-access",
          "question": "Posso prendere in gestione un profilo esistente o invitare un collega?",
          "paragraphs": [
            "Il nome o l’email pubblica non conferiscono accesso. Una scheda esistente richiede verifica della titolarità e assegnazione autorizzata. Inviti e gestione condivisa non sono ancora disponibili."
          ],
          "keywords": [
            "Posso prendere in gestione un profilo esistente o invitare un collega?",
            "Can I manage an existing profile or invite a colleague?"
          ],
          "sourceQuestions": [
            14
          ],
          "links": [
            {
              "to": "/for-entities#entity-roles-responsibility",
              "label": "Ruoli e gestione delle schede"
            }
          ]
        },
        {
          "id": "faq-declared-information",
          "question": "Le informazioni e le certificazioni sono verificate?",
          "paragraphs": [
            "Le informazioni dei profili sono dichiarate dai soggetti, salvo un’indicazione specifica di verifica. La completezza misura quanto è compilata la scheda: non è una certificazione, un punteggio di sostenibilità o una garanzia."
          ],
          "keywords": [
            "Le informazioni e le certificazioni sono verificate?",
            "Are profile information and certifications verified?"
          ],
          "sourceQuestions": [
            21
          ],
          "links": [
            {
              "to": "/how-it-works#promoters-proposals",
              "label": "Informazioni sui promotori"
            }
          ]
        },
        {
          "id": "faq-authorized-representative",
          "question": "Sono socio o volontario: posso aprire una scheda a nome dell’associazione?",
          "paragraphs": [
            "Essere socio, volontario o ex socio non basta. Per rappresentare un’organizzazione occorre esserne autorizzati. In mancanza di delega usa la tua scheda personale e non presentare progetti o incassi come ufficiali dell’ente. I campi di ruolo e affiliazione sono dichiarazioni, non verifiche documentali; non attribuiscono proprietà di altre schede."
          ],
          "keywords": [
            "Sono socio o volontario: posso aprire una scheda a nome dell’associazione?",
            "Can a member or volunteer register on behalf of an organization?"
          ],
          "sourceQuestions": [
            27
          ],
          "links": [
            {
              "to": "/for-entities#entity-roles-responsibility",
              "label": "Rappresentanza e responsabilità"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-plans-payments",
      "title": "Free, Pro e pagamenti",
      "symbol": "choices",
      "legacyIds": [],
      "items": [
        {
          "id": "faq-free-plan",
          "question": "Cosa posso fare gratuitamente?",
          "paragraphs": [
            "L’account personale è gratuito e non richiede Pro per partecipare. Il profilo Free permette di presentare la tua realtà nell’Atlante, con contatti, cataloghi, un prodotto o produzione e un marchio. Solo Comuni ed enti pubblici possono aggiungere un progetto con Free."
          ],
          "keywords": [
            "Cosa posso fare gratuitamente?",
            "What can I do for free?"
          ],
          "sourceQuestions": [
            2
          ],
          "links": [
            {
              "to": "/plans",
              "label": "Confronta Free e Pro"
            }
          ]
        },
        {
          "id": "faq-pro-price",
          "question": "Quanto costa Pro?",
          "paragraphs": [
            "Pro costa {annualPrice}, con addebito unico annuale e rinnovo automatico disattivabile."
          ],
          "keywords": [
            "prezzo abbonamento 50 euro annuale anno IVA price subscription year VAT",
            "Quanto costa Pro?",
            "How much does Pro cost?"
          ],
          "sourceQuestions": [
            9
          ],
          "links": [
            {
              "to": "/plans",
              "label": "Prezzo, funzionalità e condizioni"
            }
          ]
        },
        {
          "id": "faq-stop-renewal",
          "question": "Come interrompo il rinnovo di Pro?",
          "paragraphs": [
            "Apri Piano e incassi del soggetto, poi Gestisci abbonamento. La disdetta nel portale Stripe interrompe il rinnovo automatico: Pro resta disponibile fino alla fine dell’annualità pagata. Non cancella il profilo e non costituisce una richiesta di rimborso."
          ],
          "keywords": [
            "Come interrompo il rinnovo di Pro?",
            "How do I stop Pro renewal?"
          ],
          "sourceQuestions": [
            10
          ],
          "links": [
            {
              "to": "/plans#pro-subscription",
              "label": "Rinnovo e disdetta"
            },
            {
              "to": "/subscription-terms#subscription-refunds",
              "label": "Condizioni di rimborso di Pro"
            }
          ]
        },
        {
          "id": "faq-payment-confirmation",
          "question": "Come verifico che un pagamento sia riuscito?",
          "paragraphs": [
            "Controlla l’esito in «I tuoi pagamenti». Il solo ritorno al sito dopo il checkout non conferma il successo: considera lo stato verificato del pagamento."
          ],
          "keywords": [
            "Come verifico il pagamento o gestisco un abbonamento?",
            "How do I check payment or manage a subscription?"
          ],
          "sourceQuestions": [
            20
          ],
          "links": [
            {
              "to": "/payments/history",
              "label": "Apri I tuoi pagamenti"
            }
          ]
        },
        {
          "id": "faq-manage-pro",
          "question": "Come gestisco il mio abbonamento Pro?",
          "paragraphs": [
            "Dalla dashboard apri «Piano e incassi» della scheda interessata, poi «Gestisci abbonamento». Quando disponibile, il portale Stripe permette di gestire fatture, metodo di pagamento, rinnovo e disdetta. Se gestisci più schede, scegli quella corretta."
          ],
          "keywords": [
            "Come verifico il pagamento o gestisco un abbonamento?",
            "How do I check payment or manage a subscription?"
          ],
          "sourceQuestions": [
            20
          ],
          "links": [
            {
              "to": "/plans#pro-subscription",
              "label": "Dettagli sull’abbonamento Pro"
            }
          ]
        },
        {
          "id": "faq-can-pay-offer",
          "question": "Come capisco se posso pagare un’offerta?",
          "paragraphs": [
            "Verifica la disponibilità nella scheda e nel checkout. Puoi procedere solo quando il pagamento dell’offerta è abilitato e sono indicati beneficiario, importo e condizioni. Se non è disponibile, usa i contatti indicati. Gli addebiti live sono reali; le carte fittizie appartengono soltanto all’ambiente di test separato."
          ],
          "keywords": [
            "I pagamenti sono già attivi?",
            "Are payments active?"
          ],
          "sourceQuestions": [
            19
          ],
          "links": [
            {
              "to": "/how-it-works#account-payments",
              "label": "Account e conferma dei pagamenti"
            }
          ]
        },
        {
          "id": "faq-receive-payments",
          "question": "Cosa serve per ricevere pagamenti sulle mie offerte?",
          "paragraphs": [
            "Il beneficiario deve collegare e abilitare il proprio account Stripe e impostare un’offerta con importo e condizioni completi. Pubblicare una scheda o acquistare Pro non attiva da solo gli incassi. Verifica la disponibilità dell’offerta prima di proporre un pagamento."
          ],
          "keywords": [
            "Posso già incassare contributi per un progetto?",
            "Can I already collect project contributions?"
          ],
          "sourceQuestions": [
            39
          ],
          "links": [
            {
              "to": "/plans#pro-payments-fees",
              "label": "Requisiti per gli incassi e commissioni"
            }
          ]
        },
        {
          "id": "faq-offer-fees",
          "question": "Quali commissioni si applicano alle offerte?",
          "paragraphs": [
            "La commissione della piattaforma dipende dalla formula ed è a carico del promotore. I costi del servizio di pagamento sono separati e restano applicabili anche quando la commissione della piattaforma è zero. L’abbonamento Pro è distinto da questi costi."
          ],
          "keywords": [
            "commissioni percentuali 0% 2% 5% 100 euro fees percentages costi processor sponsorship"
          ],
          "sourceQuestions": [],
          "links": [
            {
              "to": "/plans#pro-payments-fees",
              "label": "Percentuali, offerte Free preesistenti e incassi"
            },
            {
              "to": "/subscription-terms#subscription-offer-payments",
              "label": "Condizioni delle offerte e commissioni"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-adoption",
      "title": "Adozioni e sostegno",
      "symbol": "benefits",
      "legacyIds": [
        "faq-section-3"
      ],
      "items": [
        {
          "id": "faq-support-formulas",
          "question": "Quali sono le quattro formule di adozione e sostegno?",
          "paragraphs": [
            "Le formule si distinguono per ciò che l’offerta prevede. Leggi sempre durata, contenuti, disponibilità e condizioni."
          ],
          "keywords": [
            "Quali sono le quattro formule?",
            "Qual è la differenza tra adozione simbolica e adozione con benefici?",
            "What are the four arrangements?",
            "How does symbolic adoption differ from adoption with benefits?"
          ],
          "sourceQuestions": [
            15,
            17
          ],
          "links": [
            {
              "to": "/how-it-works",
              "label": "Scopri le formule di partecipazione"
            }
          ],
          "bullets": [
            "Adozione con benefici: prodotti, servizi o esperienze previsti dall’offerta, con modalità di consegna, ritiro o partecipazione.",
            "Sostegno simbolico: sostegno senza prodotti o servizi commerciali promessi; eventuali aggiornamenti o riconoscimenti sono descritti nella scheda.",
            "Contributo a progetto: risorse per l’iniziativa e il beneficiario indicati.",
            "Sponsorizzazione: sostegno con visibilità o altri impegni concordati."
          ]
        },
        {
          "id": "faq-adoption-ownership",
          "question": "Adottare significa diventare proprietario?",
          "paragraphs": [
            "No. L’adozione non trasferisce automaticamente la proprietà della pianta, dell’animale o dell’area. La formula deve indicare durata, contenuti e condizioni."
          ],
          "keywords": [
            "Adottare significa diventare proprietario?",
            "Does adoption make me an owner?"
          ],
          "sourceQuestions": [
            16
          ],
          "links": []
        },
        {
          "id": "faq-contribution-recipient",
          "question": "A chi va il contributo?",
          "paragraphs": [
            "La scheda e la pagina di pagamento indicano il beneficiario. Sostenere una realtà o un progetto è distinto dall’abbonamento Pro e dal sostegno allo sviluppo di PlantAdopting. Un contributo non attiva un piano e non garantisce agevolazioni fiscali."
          ],
          "keywords": [
            "A chi va il contributo?",
            "Who receives my contribution?"
          ],
          "sourceQuestions": [
            18
          ],
          "links": [
            {
              "to": "/plans#pro-contributions",
              "label": "Abbonamento e contributi"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-catalogues",
      "title": "Cataloghi e compilazione",
      "symbol": "document",
      "legacyIds": [
        "faq-section-4"
      ],
      "items": [
        {
          "id": "faq-crops-gardens",
          "question": "Coltivazioni agricole e gestione di orti sono la stessa scelta?",
          "paragraphs": [
            "No. Sono selezioni separate. Coltivazioni agricole descrive le colture aziendali, comprese le produzioni orticole. Gestione di orti descrive un orto familiare, scolastico, condiviso o urbano: il nome non indica automaticamente un contesto specifico. Seleziona entrambe solo se entrambe pertinenti. Una scheda già registrata come agricola non viene trasformata automaticamente in orto."
          ],
          "keywords": [
            "Coltivazioni agricole e gestione di orti sono la stessa scelta?",
            "Are agricultural crops and food gardens the same selection?"
          ],
          "sourceQuestions": [
            6
          ],
          "links": []
        },
        {
          "id": "faq-species-activity",
          "question": "Una specie indica automaticamente l’attività o lo stato dell’impianto?",
          "paragraphs": [
            "No. Una specie può avere usi diversi: un albero non implica attività forestale, un fungo micorrizico non prova una tartufaia produttiva e una selezione non certifica idoneità locale. Funghicoltura su substrati o tronchi e tartuficoltura con piante ospiti hanno percorsi distinti. Indica attività effettive, specie, gestione e stato dell’intervento."
          ],
          "keywords": [
            "Una specie indica automaticamente l’attività o lo stato dell’impianto?",
            "Does a species automatically identify the activity or planting status?"
          ],
          "sourceQuestions": [
            7
          ],
          "links": []
        },
        {
          "id": "faq-services-heritage",
          "question": "Offrire servizi significa gestire direttamente il patrimonio?",
          "paragraphs": [
            "No. Un professionista può offrire consulenza o progettazione senza gestire direttamente terreni e piante. Le attività e il patrimonio gestito sono scelte distinte. Le selezioni non assegnano proprietà o accessi ad altre schede e non verificano qualifiche, autorizzazioni o affiliazioni."
          ],
          "keywords": [
            "Offrire servizi significa gestire direttamente il patrimonio?",
            "Does providing services mean directly managing the heritage?"
          ],
          "sourceQuestions": [
            8
          ],
          "links": []
        },
        {
          "id": "faq-must-select-crops",
          "question": "Un Comune o un professionista deve indicare cosa coltiva?",
          "paragraphs": [
            "No. Seleziona Coltivazioni agricole se le svolgi, oppure Gestione di orti se gestisci un orto. Sono scelte indipendenti e aprono il catalogo delle colture. Per piante ornamentali, forestali o altro patrimonio vegetale sono disponibili specie e cultivar senza dichiarare coltivazioni agricole. Gli allevamenti hanno selettori per specie e razze."
          ],
          "keywords": [
            "Un Comune o un professionista deve indicare cosa coltiva?",
            "Must a municipality or professional select crops?"
          ],
          "sourceQuestions": [
            13
          ],
          "links": []
        },
        {
          "id": "faq-catalogue-coverage",
          "question": "Quali colture e varietà posso trovare nei cataloghi?",
          "paragraphs": [
            "Trovi colture agricole, riferimenti botanici e razze animali; la copertura varia per specie ed è in ampliamento. Scegli prima la specie e cerca per nome o sinonimi disponibili. Fonti e date aiutano a interpretare gli archivi. Riferimenti diversi non sono sempre varietà geneticamente distinte; le denominazioni inserite liberamente restano dichiarate dal soggetto."
          ],
          "keywords": [
            "vite olivo fruttiferi agrumi cereali ortaggi leguminose grape olive fruit citrus cereals vegetables legumes",
            "Quali colture e varietà posso trovare nei cataloghi?",
            "Which crops and cultivars are included in the catalogs?"
          ],
          "sourceQuestions": [
            22
          ],
          "links": [
            {
              "to": "/for-farmers#farmer-crops-areas",
              "label": "Colture, varietà e appezzamenti"
            }
          ]
        },
        {
          "id": "faq-search-no-results",
          "question": "Perché una ricerca non mostra risultati?",
          "paragraphs": [
            "Potrebbero non esserci ancora soggetti o progetti corrispondenti ai filtri. Prova a togliere la varietà, ampliare il territorio o azzerare i filtri. Un elenco vuoto non significa necessariamente che il catalogo non contenga quella coltura. Se compare un errore di caricamento, riprova: è diverso dall’assenza di risultati."
          ],
          "keywords": [
            "Perché una ricerca non mostra risultati?",
            "Why does a search return no results?"
          ],
          "sourceQuestions": [
            23
          ],
          "links": []
        }
      ]
    },
    {
      "id": "faq-organizations",
      "title": "Organizzazioni e luoghi",
      "symbol": "community",
      "legacyIds": [
        "faq-section-5"
      ],
      "items": [
        {
          "id": "faq-organization-or-place",
          "question": "Devo registrare l’organizzazione o il luogo che gestisce?",
          "paragraphs": [
            "L’organizzazione racconta chi opera; la scheda del luogo descrive lo spazio gestito. Possono avere schede distinte: chiarisci il rapporto, il gestore e il titolo di gestione. Per l’organizzazione scegli Associazione / fondazione; per un luogo usa il percorso Parco, giardino o centro educativo e la tipologia effettiva.",
            "Anche oasi educative, giardini storici, orti botanici, arboreti e centri ambientali senza status di area protetta possono partecipare. La registrazione o il nome «oasi» non attribuiscono tutela legale. Non duplicare lo stesso progetto: indica un promotore e gli altri soggetti come partner; il collegamento non assegna accessi condivisi."
          ],
          "keywords": [
            "Registro l’associazione oppure la riserva o il giardino?",
            "Che differenza c’è tra riserva, oasi educativa e giardino storico?",
            "Should I register an organization or its reserve or garden?",
            "How do I distinguish a reserve, an educational oasis and a historic garden?"
          ],
          "sourceQuestions": [
            25,
            28
          ],
          "links": [
            {
              "to": "/for-entities#entity-category-profile",
              "label": "Scegliere categoria e profilo"
            }
          ]
        },
        {
          "id": "faq-operating-scope",
          "question": "Locale, nazionale, internazionale e sovranazionale significano la stessa cosa?",
          "paragraphs": [
            "No. L’ambito operativo descrive dove si svolge l’attività, non la forma giuridica. Un’associazione internazionale può essere privata; sovranazionale / intergovernativo indica una natura istituzionale differente. Sezione locale, associazione autonoma affiliata e sede nazionale non sono necessariamente lo stesso soggetto legale. Indica identità e rete di riferimento senza presumere gerarchia o mandato."
          ],
          "keywords": [
            "Locale, nazionale, internazionale e sovranazionale significano la stessa cosa?",
            "Are local, national, international and supranational interchangeable?"
          ],
          "sourceQuestions": [
            26
          ],
          "links": [
            {
              "to": "/for-entities#entity-roles-responsibility",
              "label": "Reti, ruoli e responsabilità"
            }
          ]
        },
        {
          "id": "faq-international-organization",
          "question": "Una fondazione internazionale può partecipare?",
          "paragraphs": [
            "Sì, tramite una persona autorizzata e con un’identità chiara. Può presentare conservazione, ripristino ecologico, educazione o ricerca di partner. La registrazione non prova adesioni di organizzazioni note e non garantisce interesse o finanziamenti. Pagamenti e servizi dipendono anche dai paesi e dai requisiti effettivamente supportati."
          ],
          "keywords": [
            "Una fondazione internazionale può partecipare?",
            "Can an international foundation participate?"
          ],
          "sourceQuestions": [
            29
          ],
          "links": []
        },
        {
          "id": "faq-professional-services",
          "question": "Come presento consulenze, corsi e lavori professionali?",
          "paragraphs": [
            "Il portfolio racconta lavori svolti; i servizi descrivono consulenze, sopralluoghi o progettazione da richiedere tramite i contatti. Un’opportunità propone invece un’attività a cui aderire: per esempio un corso come Formazione, una visita come Visita o un intervento articolato come Progetto.",
            "Indica prestazioni comprese, destinatari, territorio, tempi, compenso o modalità di preventivo e requisiti professionali pertinenti. Non serve trasformare ogni servizio in una raccolta fondi o un’adozione."
          ],
          "keywords": [
            "Quali opportunità può proporre un professionista del verde?",
            "What opportunities can a green professional offer?"
          ],
          "sourceQuestions": [
            36
          ],
          "links": [
            {
              "to": "/for-entities#entity-category-profile",
              "label": "Profilo professionale e servizi"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-projects",
      "title": "Progetti e raccolte",
      "symbol": "territory",
      "legacyIds": [
        "faq-section-6",
        "faq-section-7"
      ],
      "items": [
        {
          "id": "faq-create-project",
          "question": "Come inserisco un progetto?",
          "paragraphs": [
            "Comuni ed enti pubblici possono aggiungere un progetto con Free durante la registrazione o dalla dashboard. Per aziende, professionisti, associazioni e gestori di luoghi occorre Pro; le coperture a vita già previste restano valide.",
            "Indica obiettivo, area, attività, partecipazione, periodo, avanzamento e partner; quando pertinenti, superficie, responsabile, obiettivi misurabili, costi, manutenzione e autorizzazioni. Puoi collegare altre opportunità dello stesso soggetto."
          ],
          "keywords": [
            "Come inserisco un progetto?",
            "How can I add a project?"
          ],
          "sourceQuestions": [
            24
          ],
          "links": [
            {
              "to": "/plans",
              "label": "Funzionalità e requisiti dei piani"
            }
          ]
        },
        {
          "id": "faq-projects-on-other-land",
          "question": "Un’associazione può proporre la rinaturalizzazione di un’area che non possiede?",
          "paragraphs": [
            "Può descrivere una proposta e cercare partner, distinguendola da un intervento autorizzato. Per realizzarla servono disponibilità dell’area, accordi con chi può disporne e gli assensi richiesti. Su aree pubbliche occorre il coinvolgimento dell’ente competente; su quelle private il titolo o consenso appropriato; su aree miste vanno chiarite tutte le parti. Essere proprietario o gestore non elimina gli eventuali vincoli ambientali, paesaggistici o archeologici.",
            "Convenzioni, sponsorizzazioni e acquisti pubblici seguono le procedure dell’ente: la scheda non le sostituisce."
          ],
          "keywords": [
            "Un’associazione può proporre la rinaturalizzazione di un’area che non possiede?",
            "Can an association propose restoration on land it does not own?"
          ],
          "sourceQuestions": [
            31
          ],
          "links": [
            {
              "to": "/for-entities#entity-project-land",
              "label": "Progetti su aree pubbliche, private o miste"
            }
          ]
        },
        {
          "id": "faq-habitat-projects",
          "question": "Cosa possono proporre riserve, giardini, oasi e centri educativi?",
          "paragraphs": [
            "Riserve, giardini, oasi e centri educativi possono proporre, per esempio, monitoraggio degli habitat, cura dei sentieri, laboratori e visite. Ogni proposta deve rispettare finalità del soggetto, caratteristiche del luogo e autorizzazioni necessarie.",
            "Ripristinare un habitat non significa necessariamente piantare alberi: specie e tecniche vanno scelte secondo obiettivi ecologici e regole di tutela."
          ],
          "keywords": [
            "Cosa possono proporre riserve, giardini, oasi e centri educativi?",
            "What can reserves, gardens, oases and educational centers propose?"
          ],
          "sourceQuestions": [
            33
          ],
          "links": [
            {
              "to": "/for-entities",
              "label": "Percorso per enti e luoghi"
            }
          ]
        },
        {
          "id": "faq-project-opportunity-formula",
          "question": "Che differenza c’è tra progetto, opportunità e formula di pagamento?",
          "paragraphs": [
            "Il progetto descrive un obiettivo e un insieme di attività. Le opportunità sono azioni concrete: acquisto, adozione, visita, formazione, volontariato, sostegno o progetto. La formula economica è un’altra scelta: benefici commerciali, sostegno simbolico, contributo a progetto o sponsorizzazione. Non ogni progetto raccoglie denaro e non ogni opportunità è una donazione. Le etichette dei selettori seguono la lingua del sito."
          ],
          "keywords": [
            "Che differenza c’è tra progetto, opportunità e formula di pagamento?",
            "How do projects, opportunities and payment arrangements differ?"
          ],
          "sourceQuestions": [
            35
          ],
          "links": []
        },
        {
          "id": "faq-volunteering",
          "question": "Come organizzare una giornata di volontariato?",
          "paragraphs": [
            "Indica promotore, referente, attività, requisiti, rischi, attrezzature e modalità di adesione. Il promotore deve verificare le regole applicabili, incluse sicurezza e coperture assicurative quando previste. Volontariato non significa lavoro gratuito senza regole e non sostituisce gli obblighi di un rapporto di lavoro."
          ],
          "keywords": [
            "Come organizzare una giornata di volontariato?",
            "How should a volunteering day be organized?"
          ],
          "sourceQuestions": [
            37
          ],
          "links": [
            {
              "to": "/for-entities#entity-activity-requirements",
              "label": "Volontariato e requisiti delle attività"
            }
          ]
        },
        {
          "id": "faq-fundraising-limits",
          "question": "PlantAdopting gestisce raccolte «tutto o niente» o investimenti?",
          "paragraphs": [
            "No. Non sono disponibili raccolte tutto-o-niente, deposito vincolato, prestiti, quote societarie o rendimenti finanziari. La raccolta fondi indica più in generale il reperimento di risorse; il crowdfunding si rivolge a molti sostenitori, spesso online.",
            "Contributi senza ritorno economico, benefici o ricompense, sponsorizzazioni e vendite sono distinti. Chiamare una vendita o una sponsorizzazione «donazione» non ne cambia la natura."
          ],
          "keywords": [
            "Raccolta fondi e crowdfunding sono sinonimi?",
            "Do fundraising and crowdfunding mean the same thing?"
          ],
          "sourceQuestions": [
            38
          ],
          "links": [
            {
              "to": "/how-it-works#project-goals-refunds",
              "label": "Obiettivi dei progetti e rimborsi"
            }
          ]
        },
        {
          "id": "faq-missed-project-goal",
          "question": "Se non raggiungo l’obiettivo economico, il denaro viene restituito automaticamente?",
          "paragraphs": [
            "No. Un obiettivo economico o un indicatore di avanzamento non garantisce la restituzione: non c’è un meccanismo tutto-o-niente, deposito vincolato o rimborso automatico per mancato obiettivo. Prima di contribuire devono essere chiari beneficiario, impiego dei fondi, tempi, commissioni, imprevisti e condizioni di rimborso. Restano validi i diritti applicabili e le condizioni più favorevoli dell’offerta."
          ],
          "keywords": [
            "Se non raggiungo l’obiettivo economico, il denaro viene restituito automaticamente?",
            "Are contributions automatically refunded if a funding target is missed?"
          ],
          "sourceQuestions": [
            40
          ],
          "links": [
            {
              "to": "/how-it-works#project-goals-refunds",
              "label": "Obiettivi e condizioni dei progetti"
            }
          ]
        },
        {
          "id": "faq-fundraising-tax",
          "question": "Chi risponde della raccolta e delle agevolazioni fiscali?",
          "paragraphs": [
            "Il soggetto beneficiario deve essere identificato e legittimato a raccogliere le risorse. Gli ETS seguono le norme applicabili alla raccolta e alla rendicontazione; enti pubblici e altri soggetti seguono i propri obblighi. Registrarsi come associazione non prova l’iscrizione al RUNTS. Una ricevuta di pagamento non dimostra automaticamente una donazione fiscalmente agevolata: condizioni e documentazione dipendono dal beneficiario e dall’operazione."
          ],
          "keywords": [
            "Chi risponde della raccolta e delle agevolazioni fiscali?",
            "Who is responsible for fundraising and tax relief?"
          ],
          "sourceQuestions": [
            41
          ],
          "links": [
            {
              "to": "/terms#terms-offers",
              "label": "Partecipazione e offerte"
            }
          ]
        }
      ]
    }
  ],
  "en": [
    {
      "id": "faq-start",
      "title": "Getting started and participating",
      "symbol": "handshake",
      "legacyIds": [
        "faq-section-1"
      ],
      "items": [
        {
          "id": "faq-why-join",
          "question": "Why join if I already have a website or social media?",
          "paragraphs": [
            "PlantAdopting complements your website and social channels with a profile connected to your location, activities and living heritage. It helps visitors understand your work and contact you; it does not guarantee customers, contributions or collaborations."
          ],
          "keywords": [
            "vivaio nursery cittadini adottanti citizens adopters vantaggi benefits",
            "Perché partecipare se ho già un sito o i social?",
            "Perché dovrei iscrivermi a PlantAdopting?",
            "Why join if I already have a website or social media?",
            "Why should I join PlantAdopting?"
          ],
          "sourceQuestions": [
            1,
            4
          ],
          "links": [
            {
              "to": "/for-farmers",
              "label": "For farms and nurseries"
            },
            {
              "to": "/for-entities",
              "label": "Organizations, professionals and places"
            }
          ]
        },
        {
          "id": "faq-explore-account",
          "question": "Do I need an account to explore?",
          "paragraphs": [
            "No. Browse the map, Atlas, catalogs and public profiles without an account. Payments through PlantAdopting and managing your profiles require a free account; contacts and activities on external sites follow the stated channel."
          ],
          "keywords": [
            "Devo iscrivermi anche solo per curiosare?",
            "Devo registrarmi per esplorare?",
            "Do I need to register just to look around?",
            "Do I need an account to explore?"
          ],
          "sourceQuestions": [
            5,
            11
          ],
          "links": [
            {
              "to": "/how-it-works#account-payments",
              "label": "Accounts and participation"
            }
          ]
        },
        {
          "id": "faq-activities",
          "question": "What activities can I offer?",
          "paragraphs": [
            "Available types are purchase, adoption, visit, learning, volunteering, support and project. Choose according to the actual activity and applicable requirements, not only the promoter’s category.",
            "Examples include farm products, a farm visit, a workshop or garden restoration. Creating opportunities requires Pro, except one Free project for municipalities and public bodies. Publication, booking and payment collection are separate; external shops or contacts follow the stated channel."
          ],
          "keywords": [
            "acquisti prodotti allevamento siepi impollinatori orto scolastico acqua purchase livestock hedgerow pollinator school garden water",
            "Quali opportunità possono proporre i diversi soggetti?",
            "Quali esempi di progetti possono proporre Comuni ed enti?",
            "Cosa può proporre un’azienda agricola o un allevamento?",
            "Which opportunities can different subjects offer?",
            "What projects can municipalities and public bodies propose?",
            "What can a farm or livestock farm offer?"
          ],
          "sourceQuestions": [
            30,
            32,
            34
          ],
          "links": [
            {
              "to": "/for-farmers",
              "label": "Farms and nurseries"
            },
            {
              "to": "/for-entities",
              "label": "Organizations, professionals and places"
            },
            {
              "to": "/how-it-works",
              "label": "Ways to participate"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-accounts",
      "title": "Accounts and profiles",
      "symbol": "citizen",
      "legacyIds": [
        "faq-section-2"
      ],
      "items": [
        {
          "id": "faq-profile-visible",
          "question": "How do I make my profile visible?",
          "paragraphs": [
            "Create your personal account, add the organization or place you are authorized to represent or manage, then complete and save the profile: it will be available in the Atlas. Accounts and profiles are separate; no additional publishing step is needed."
          ],
          "keywords": [
            "Come rendo visibile la mia scheda?",
            "How do I make my profile visible?"
          ],
          "sourceQuestions": [
            3
          ],
          "links": [
            {
              "to": "/terms#terms-content",
              "label": "Content and permissions"
            }
          ]
        },
        {
          "id": "faq-adopter-and-manager",
          "question": "Can I be an adopter and manage an activity?",
          "paragraphs": [
            "Yes. One account can participate and manage multiple subjects it owns. If you have no activity to register, use the platform as an adopter without creating a business profile."
          ],
          "keywords": [
            "Posso essere adottante e gestire un’attività?",
            "Can I be an adopter and manage an activity?"
          ],
          "sourceQuestions": [
            12
          ],
          "links": []
        },
        {
          "id": "faq-existing-profile-access",
          "question": "Can I manage an existing profile or invite a colleague?",
          "paragraphs": [
            "Names and public emails do not grant access. Existing profiles require ownership verification and authorized assignment. Invitations and shared management are not yet available."
          ],
          "keywords": [
            "Posso prendere in gestione un profilo esistente o invitare un collega?",
            "Can I manage an existing profile or invite a colleague?"
          ],
          "sourceQuestions": [
            14
          ],
          "links": [
            {
              "to": "/for-entities#entity-roles-responsibility",
              "label": "Roles and profile management"
            }
          ]
        },
        {
          "id": "faq-declared-information",
          "question": "Are profile information and certifications verified?",
          "paragraphs": [
            "Subjects declare their profile information unless a specific verification is stated. Completeness measures how much of the profile is filled in; it is not certification, a sustainability score or a guarantee."
          ],
          "keywords": [
            "Le informazioni e le certificazioni sono verificate?",
            "Are profile information and certifications verified?"
          ],
          "sourceQuestions": [
            21
          ],
          "links": [
            {
              "to": "/how-it-works#promoters-proposals",
              "label": "About promoters"
            }
          ]
        },
        {
          "id": "faq-authorized-representative",
          "question": "Can a member or volunteer register on behalf of an organization?",
          "paragraphs": [
            "Membership, volunteering or former membership is not sufficient authority. You must be authorized to represent the organization. Without delegation use a personal profile and do not present projects or payments as official organizational activities. Role and affiliation fields are declarations, not document verification, and do not grant ownership of other profiles."
          ],
          "keywords": [
            "Sono socio o volontario: posso aprire una scheda a nome dell’associazione?",
            "Can a member or volunteer register on behalf of an organization?"
          ],
          "sourceQuestions": [
            27
          ],
          "links": [
            {
              "to": "/for-entities#entity-roles-responsibility",
              "label": "Representation and responsibilities"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-plans-payments",
      "title": "Free, Pro and payments",
      "symbol": "choices",
      "legacyIds": [],
      "items": [
        {
          "id": "faq-free-plan",
          "question": "What can I do for free?",
          "paragraphs": [
            "Your personal account is free and does not require Pro to participate. A Free profile presents your farm, organization or place in the Atlas, with contacts, catalogs, one product or production entry and one brand. Only municipalities and public bodies can also add one project with Free."
          ],
          "keywords": [
            "Cosa posso fare gratuitamente?",
            "What can I do for free?"
          ],
          "sourceQuestions": [
            2
          ],
          "links": [
            {
              "to": "/plans",
              "label": "Compare Free and Pro"
            }
          ]
        },
        {
          "id": "faq-pro-price",
          "question": "How much does Pro cost?",
          "paragraphs": [
            "Pro costs {annualPrice}, charged once annually with automatic renewal that you can turn off."
          ],
          "keywords": [
            "prezzo abbonamento 50 euro annuale anno IVA price subscription year VAT",
            "Quanto costa Pro?",
            "How much does Pro cost?"
          ],
          "sourceQuestions": [
            9
          ],
          "links": [
            {
              "to": "/plans",
              "label": "Pricing, features and terms"
            }
          ]
        },
        {
          "id": "faq-stop-renewal",
          "question": "How do I stop Pro renewal?",
          "paragraphs": [
            "Open the subject’s Plan and payments, then Manage subscription. Cancellation in the Stripe portal stops automatic renewal: Pro remains available until the end of the paid annual period. It does not delete the profile or constitute a refund request."
          ],
          "keywords": [
            "Come interrompo il rinnovo di Pro?",
            "How do I stop Pro renewal?"
          ],
          "sourceQuestions": [
            10
          ],
          "links": [
            {
              "to": "/plans#pro-subscription",
              "label": "Renewal and cancellation"
            },
            {
              "to": "/subscription-terms#subscription-refunds",
              "label": "Pro refund terms"
            }
          ]
        },
        {
          "id": "faq-payment-confirmation",
          "question": "How do I check whether a payment succeeded?",
          "paragraphs": [
            "Check the status in “Your payments”. Returning to the website after checkout alone does not confirm success: rely on the verified payment status."
          ],
          "keywords": [
            "Come verifico il pagamento o gestisco un abbonamento?",
            "How do I check payment or manage a subscription?"
          ],
          "sourceQuestions": [
            20
          ],
          "links": [
            {
              "to": "/payments/history",
              "label": "Open Your payments"
            }
          ]
        },
        {
          "id": "faq-manage-pro",
          "question": "How do I manage my Pro subscription?",
          "paragraphs": [
            "From the dashboard, open “Plan and payments” for the relevant profile, then “Manage subscription”. Where available, the Stripe portal manages invoices, payment methods, renewal and cancellation. If you manage several profiles, choose the relevant one."
          ],
          "keywords": [
            "Come verifico il pagamento o gestisco un abbonamento?",
            "How do I check payment or manage a subscription?"
          ],
          "sourceQuestions": [
            20
          ],
          "links": [
            {
              "to": "/plans#pro-subscription",
              "label": "Pro subscription details"
            }
          ]
        },
        {
          "id": "faq-can-pay-offer",
          "question": "How can I tell whether an offer accepts payment?",
          "paragraphs": [
            "Check availability on the offer and at checkout. You can proceed only when the offer’s payment is enabled and the recipient, amount and terms are stated. If payment is unavailable, use the provided contacts. Live charges are real; test cards belong only in the separate test environment."
          ],
          "keywords": [
            "I pagamenti sono già attivi?",
            "Are payments active?"
          ],
          "sourceQuestions": [
            19
          ],
          "links": [
            {
              "to": "/how-it-works#account-payments",
              "label": "Accounts and payment confirmation"
            }
          ]
        },
        {
          "id": "faq-receive-payments",
          "question": "What do I need to receive payments for my offers?",
          "paragraphs": [
            "The recipient must connect and enable their Stripe account and configure an offer with a complete amount and terms. Publishing a profile or purchasing Pro does not itself enable payment collection. Check the offer’s availability before inviting payment."
          ],
          "keywords": [
            "Posso già incassare contributi per un progetto?",
            "Can I already collect project contributions?"
          ],
          "sourceQuestions": [
            39
          ],
          "links": [
            {
              "to": "/plans#pro-payments-fees",
              "label": "Payment collection requirements and fees"
            }
          ]
        },
        {
          "id": "faq-offer-fees",
          "question": "What fees apply to offers?",
          "paragraphs": [
            "The platform fee depends on the arrangement and is charged to the promoter. Payment processor costs are separate and still apply when the platform fee is zero. The Pro subscription is separate from these costs."
          ],
          "keywords": [
            "commissioni percentuali 0% 2% 5% 100 euro fees percentages costi processor sponsorship"
          ],
          "sourceQuestions": [],
          "links": [
            {
              "to": "/plans#pro-payments-fees",
              "label": "Rates, existing Free offers and payment collection"
            },
            {
              "to": "/subscription-terms#subscription-offer-payments",
              "label": "Offer payment and fee terms"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-adoption",
      "title": "Adoption and support",
      "symbol": "benefits",
      "legacyIds": [
        "faq-section-3"
      ],
      "items": [
        {
          "id": "faq-support-formulas",
          "question": "What are the four adoption and support arrangements?",
          "paragraphs": [
            "The arrangements differ in what the offer provides. Always check duration, contents, availability and terms."
          ],
          "keywords": [
            "Quali sono le quattro formule?",
            "Qual è la differenza tra adozione simbolica e adozione con benefici?",
            "What are the four arrangements?",
            "How does symbolic adoption differ from adoption with benefits?"
          ],
          "sourceQuestions": [
            15,
            17
          ],
          "links": [
            {
              "to": "/how-it-works",
              "label": "Explore ways to participate"
            }
          ],
          "bullets": [
            "Adoption with benefits: products, services or experiences stated in the offer, with delivery, collection or participation arrangements.",
            "Symbolic support: support without promised commercial products or services; any updates or recognition are described in the offer.",
            "Project contribution: resources for the stated initiative and recipient.",
            "Sponsorship: support with agreed visibility or other commitments."
          ]
        },
        {
          "id": "faq-adoption-ownership",
          "question": "Does adoption make me an owner?",
          "paragraphs": [
            "No. Adoption does not automatically transfer ownership of a plant, animal or area. Arrangements must state duration, what is included and terms."
          ],
          "keywords": [
            "Adottare significa diventare proprietario?",
            "Does adoption make me an owner?"
          ],
          "sourceQuestions": [
            16
          ],
          "links": []
        },
        {
          "id": "faq-contribution-recipient",
          "question": "Who receives my contribution?",
          "paragraphs": [
            "The offer and payment page identify the recipient. Supporting an organization, place or project is separate from Pro and from supporting PlantAdopting’s development. A contribution does not activate a plan or guarantee tax benefits."
          ],
          "keywords": [
            "A chi va il contributo?",
            "Who receives my contribution?"
          ],
          "sourceQuestions": [
            18
          ],
          "links": [
            {
              "to": "/plans#pro-contributions",
              "label": "Subscriptions and contributions"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-catalogues",
      "title": "Catalogs and profile details",
      "symbol": "document",
      "legacyIds": [
        "faq-section-4"
      ],
      "items": [
        {
          "id": "faq-crops-gardens",
          "question": "Are agricultural crops and food gardens the same selection?",
          "paragraphs": [
            "No. They are separate choices. Agricultural crop production describes farm crops, including commercial vegetable production. Food garden management describes a domestic, school, community or urban food garden; the label does not automatically imply any particular setting. Select both only when both apply. Existing agricultural profiles are not automatically reclassified as food gardens."
          ],
          "keywords": [
            "Coltivazioni agricole e gestione di orti sono la stessa scelta?",
            "Are agricultural crops and food gardens the same selection?"
          ],
          "sourceQuestions": [
            6
          ],
          "links": []
        },
        {
          "id": "faq-species-activity",
          "question": "Does a species automatically identify the activity or planting status?",
          "paragraphs": [
            "No. A species can have different uses: a tree does not imply forestry activity, a mycorrhizal fungus does not prove a productive truffle plantation, and a selection does not certify local suitability. Mushroom cultivation on substrates or logs and truffle cultivation with host plants have separate paths. State actual activities, species, management and intervention status."
          ],
          "keywords": [
            "Una specie indica automaticamente l’attività o lo stato dell’impianto?",
            "Does a species automatically identify the activity or planting status?"
          ],
          "sourceQuestions": [
            7
          ],
          "links": []
        },
        {
          "id": "faq-services-heritage",
          "question": "Does providing services mean directly managing the heritage?",
          "paragraphs": [
            "No. A professional may provide consulting or design without directly managing land or plants. Services and managed heritage are separate choices. Selections do not assign ownership or access to other profiles and do not verify qualifications, permissions or affiliations."
          ],
          "keywords": [
            "Offrire servizi significa gestire direttamente il patrimonio?",
            "Does providing services mean directly managing the heritage?"
          ],
          "sourceQuestions": [
            8
          ],
          "links": []
        },
        {
          "id": "faq-must-select-crops",
          "question": "Must a municipality or professional select crops?",
          "paragraphs": [
            "No. Select Agricultural crop production if applicable, or Food garden management if you manage a food garden. These are independent choices that open the crop catalog. Ornamental, forest and other managed plants have species and cultivar selectors without declaring agricultural crop production. Livestock has species and breed selectors."
          ],
          "keywords": [
            "Un Comune o un professionista deve indicare cosa coltiva?",
            "Must a municipality or professional select crops?"
          ],
          "sourceQuestions": [
            13
          ],
          "links": []
        },
        {
          "id": "faq-catalogue-coverage",
          "question": "Which crops and cultivars are included in the catalogs?",
          "paragraphs": [
            "The catalogs include agricultural crops, botanical references and animal breeds; coverage varies by species and is expanding. Choose the species first, then search by name or available synonyms. Sources and dates help interpret the archives. Separate references are not always genetically distinct cultivars; free-text names remain declarations by the profile owner."
          ],
          "keywords": [
            "vite olivo fruttiferi agrumi cereali ortaggi leguminose grape olive fruit citrus cereals vegetables legumes",
            "Quali colture e varietà posso trovare nei cataloghi?",
            "Which crops and cultivars are included in the catalogs?"
          ],
          "sourceQuestions": [
            22
          ],
          "links": [
            {
              "to": "/for-farmers#farmer-crops-areas",
              "label": "Crops, cultivars and plots"
            }
          ]
        },
        {
          "id": "faq-search-no-results",
          "question": "Why does a search return no results?",
          "paragraphs": [
            "There may be no subjects or projects matching your filters yet. Remove the cultivar filter, widen the area or reset filters. An empty list does not necessarily mean a crop is missing from the catalog. If a loading error appears, try again: this is different from having no results."
          ],
          "keywords": [
            "Perché una ricerca non mostra risultati?",
            "Why does a search return no results?"
          ],
          "sourceQuestions": [
            23
          ],
          "links": []
        }
      ]
    },
    {
      "id": "faq-organizations",
      "title": "Organizations and places",
      "symbol": "community",
      "legacyIds": [
        "faq-section-5"
      ],
      "items": [
        {
          "id": "faq-organization-or-place",
          "question": "Should I register the organization or the place it manages?",
          "paragraphs": [
            "An organization’s profile describes who operates; a place’s profile describes the managed space. They may have separate profiles: explain the relationship, manager and management basis. Choose Association / foundation for the organization; for a place, use Park, garden or educational center and its actual type.",
            "Educational oases, historic gardens, botanical gardens, arboreta and environmental centers without protected-area status can also participate. Registration or the name “oasis” does not grant legal protection. Do not duplicate the same project: name one promoter and the others as partners; a declared link does not grant shared access."
          ],
          "keywords": [
            "Registro l’associazione oppure la riserva o il giardino?",
            "Che differenza c’è tra riserva, oasi educativa e giardino storico?",
            "Should I register an organization or its reserve or garden?",
            "How do I distinguish a reserve, an educational oasis and a historic garden?"
          ],
          "sourceQuestions": [
            25,
            28
          ],
          "links": [
            {
              "to": "/for-entities#entity-category-profile",
              "label": "Choosing a category and profile"
            }
          ]
        },
        {
          "id": "faq-operating-scope",
          "question": "Are local, national, international and supranational interchangeable?",
          "paragraphs": [
            "No. Operating scope describes where activities take place, not legal form. An international association can be private; supranational / intergovernmental describes a different institutional nature. A local branch, an autonomous affiliated association and a national office are not necessarily the same legal entity. State the identity and network without implying hierarchy or authorization."
          ],
          "keywords": [
            "Locale, nazionale, internazionale e sovranazionale significano la stessa cosa?",
            "Are local, national, international and supranational interchangeable?"
          ],
          "sourceQuestions": [
            26
          ],
          "links": [
            {
              "to": "/for-entities#entity-roles-responsibility",
              "label": "Networks, roles and responsibilities"
            }
          ]
        },
        {
          "id": "faq-international-organization",
          "question": "Can an international foundation participate?",
          "paragraphs": [
            "Yes, through an authorized person with a clear identity. It can present conservation, ecological restoration, education or partnership initiatives. Registration does not imply endorsement by well-known organizations or guarantee interest or funding. Payments and services also depend on supported countries and applicable requirements."
          ],
          "keywords": [
            "Una fondazione internazionale può partecipare?",
            "Can an international foundation participate?"
          ],
          "sourceQuestions": [
            29
          ],
          "links": []
        },
        {
          "id": "faq-professional-services",
          "question": "How do I present consultancy, courses and professional work?",
          "paragraphs": [
            "A portfolio describes past work; services describe consultancy, site visits or design requested through contacts. An opportunity offers an activity people can join: for example, a course as Learning, a visit as Visit or a coordinated intervention as Project.",
            "State included services, audience, operating area, schedule, fee or quotation process and relevant professional requirements. Not every service needs to become fundraising or an adoption."
          ],
          "keywords": [
            "Quali opportunità può proporre un professionista del verde?",
            "What opportunities can a green professional offer?"
          ],
          "sourceQuestions": [
            36
          ],
          "links": [
            {
              "to": "/for-entities#entity-category-profile",
              "label": "Professional profiles and services"
            }
          ]
        }
      ]
    },
    {
      "id": "faq-projects",
      "title": "Projects and fundraising",
      "symbol": "territory",
      "legacyIds": [
        "faq-section-6",
        "faq-section-7"
      ],
      "items": [
        {
          "id": "faq-create-project",
          "question": "How can I add a project?",
          "paragraphs": [
            "Municipalities and public bodies can add one project with Free during registration or from the dashboard. Farms, professionals, associations and place managers need Pro; existing lifetime coverage remains valid.",
            "State the objective, area, activities, participation, schedule, progress and partners; where relevant, include area size, responsible party, measurable objectives, costs, maintenance and permissions. You can link other opportunities from the same profile."
          ],
          "keywords": [
            "Come inserisco un progetto?",
            "How can I add a project?"
          ],
          "sourceQuestions": [
            24
          ],
          "links": [
            {
              "to": "/plans",
              "label": "Plan features and requirements"
            }
          ]
        },
        {
          "id": "faq-projects-on-other-land",
          "question": "Can an association propose restoration on land it does not own?",
          "paragraphs": [
            "It can describe a proposal and seek partners, clearly separating a proposal from an authorized intervention. Implementation requires land availability, agreements with those entitled to grant access and any required approvals. Public land needs the competent body involved; private land needs an appropriate title or consent; mixed areas need arrangements for every part. Ownership or management does not remove environmental, landscape or archaeological restrictions.",
            "Agreements, sponsorship and public procurement remain subject to the public body’s procedures; a profile does not replace them."
          ],
          "keywords": [
            "Un’associazione può proporre la rinaturalizzazione di un’area che non possiede?",
            "Can an association propose restoration on land it does not own?"
          ],
          "sourceQuestions": [
            31
          ],
          "links": [
            {
              "to": "/for-entities#entity-project-land",
              "label": "Projects on public, private or mixed land"
            }
          ]
        },
        {
          "id": "faq-habitat-projects",
          "question": "What can reserves, gardens, oases and educational centers propose?",
          "paragraphs": [
            "Reserves, gardens, oases and educational centers can offer habitat monitoring, trail care, workshops and visits, for example. Every proposal must suit the organization’s purpose, the place and required permissions.",
            "Restoring a habitat does not necessarily mean planting trees: choose species and methods according to ecological objectives and protection rules."
          ],
          "keywords": [
            "Cosa possono proporre riserve, giardini, oasi e centri educativi?",
            "What can reserves, gardens, oases and educational centers propose?"
          ],
          "sourceQuestions": [
            33
          ],
          "links": [
            {
              "to": "/for-entities",
              "label": "Organizations and places"
            }
          ]
        },
        {
          "id": "faq-project-opportunity-formula",
          "question": "How do projects, opportunities and payment arrangements differ?",
          "paragraphs": [
            "A project describes an objective and coordinated activities. Opportunities are practical actions: purchase, adoption, visit, training, volunteering, support or project. Payment arrangements are a separate choice: commercial benefits, symbolic support, project contributions or sponsorship. Not every project collects money and not every opportunity is a donation. Selector labels follow the site language."
          ],
          "keywords": [
            "Che differenza c’è tra progetto, opportunità e formula di pagamento?",
            "How do projects, opportunities and payment arrangements differ?"
          ],
          "sourceQuestions": [
            35
          ],
          "links": []
        },
        {
          "id": "faq-volunteering",
          "question": "How should a volunteering day be organized?",
          "paragraphs": [
            "State the organizer, contact person, activities, requirements, risks, equipment and joining procedure. The organizer must check applicable rules, including safety and insurance where required. Volunteering does not mean unregulated unpaid work and does not replace employment obligations."
          ],
          "keywords": [
            "Come organizzare una giornata di volontariato?",
            "How should a volunteering day be organized?"
          ],
          "sourceQuestions": [
            37
          ],
          "links": [
            {
              "to": "/for-entities#entity-activity-requirements",
              "label": "Volunteering and activity requirements"
            }
          ]
        },
        {
          "id": "faq-fundraising-limits",
          "question": "Does PlantAdopting offer all-or-nothing fundraising or investments?",
          "paragraphs": [
            "No. All-or-nothing fundraising, escrow, loans, company shares and financial returns are not available. Fundraising is the broader activity of obtaining resources; crowdfunding addresses many supporters, often online.",
            "Contributions without financial returns, rewards or benefits, sponsorship and sales are distinct. Calling a sale or sponsorship a “donation” does not change its nature."
          ],
          "keywords": [
            "Raccolta fondi e crowdfunding sono sinonimi?",
            "Do fundraising and crowdfunding mean the same thing?"
          ],
          "sourceQuestions": [
            38
          ],
          "links": [
            {
              "to": "/how-it-works#project-goals-refunds",
              "label": "Project targets and refunds"
            }
          ]
        },
        {
          "id": "faq-missed-project-goal",
          "question": "Are contributions automatically refunded if a funding target is missed?",
          "paragraphs": [
            "No. A funding target or progress indicator does not guarantee repayment: there is no all-or-nothing mechanism, escrow or automatic missed-target refund. Before contributing, the recipient, use of funds, schedule, fees, contingencies and refund terms must be clear. Applicable rights and any more favourable offer terms remain unaffected."
          ],
          "keywords": [
            "Se non raggiungo l’obiettivo economico, il denaro viene restituito automaticamente?",
            "Are contributions automatically refunded if a funding target is missed?"
          ],
          "sourceQuestions": [
            40
          ],
          "links": [
            {
              "to": "/how-it-works#project-goals-refunds",
              "label": "Project targets and terms"
            }
          ]
        },
        {
          "id": "faq-fundraising-tax",
          "question": "Who is responsible for fundraising and tax relief?",
          "paragraphs": [
            "The beneficiary must be identified and entitled to raise the resources. Italian third-sector entities follow applicable fundraising and reporting rules; public bodies and other entities follow their own obligations. Registering as an association does not establish RUNTS registration. A payment receipt does not automatically prove a tax-eligible donation: requirements and documentation depend on the beneficiary and transaction."
          ],
          "keywords": [
            "Chi risponde della raccolta e delle agevolazioni fiscali?",
            "Who is responsible for fundraising and tax relief?"
          ],
          "sourceQuestions": [
            41
          ],
          "links": [
            {
              "to": "/terms#terms-offers",
              "label": "Participation and offers"
            }
          ]
        }
      ]
    }
  ]
};
